import { h, FunctionalComponent } from 'preact';
import { useEffect, useState } from 'preact/compat';

export const Image: FunctionalComponent<ImageProps> = (props) => {
	const { src, className, alt } = props;
	const [image, setImage] = useState('');

	useEffect(() => {
		if (typeof src === 'string') {
			setImage(src);
		} else {
			setImage(window.URL.createObjectURL(src));
		}
	}, [src]);

	return (
		<img src={image} className={className} alt={alt}/>
	);
};

interface ImageProps {
	src: string | File;
	alt?: string;
	className?: string;
}
